import api from '@/api/report'

const state = {
    items: [],
    customers: [],
    drivers: [],
    warehouses: [],
    reportURL: null,
}

const mutations = {
    set(state, payload) {
        state.items = payload
    },
    delete(state, id) {
        let index = state.items.findIndex(x => x.id == id)
        state.items.splice(index, 1)
    },
    set_drivers(state, payload) {
        state.drivers = payload
    },
    set_warehouses(state, payload) {
        state.warehouses = payload
    },
    set_customers(state, payload) {
        state.customers = payload
    },
    set_url(state, payload) {
        state.reportURL = payload
    },
}

const actions = {
    fetch(context, payload) {
        return api
            .fetch(payload)
            .then(result => {
                let items = result.data.success.data.map(x => {
                    return x
                })
                context.commit('set', items)
                console.log('report-items', items)
            })
            .catch(err => {
                throw err
            })
    },

    fetchDrivers(context) {
        return api.fetchDrivers(context).then(result => {
            let drivers = result.data.success.data.data
            context.commit('set_drivers', drivers)
        })
    },

    fetchWarehouses(context) {
        return api.fetchWarehouses(context).then(result => {
            let warehouses = result.data.success.data.data
            context.commit('set_warehouses', warehouses)
        })
    },

    

    fetchReport(context, payload) {
        return api
            .fetchReport(payload)
            .then(result => {
                console.log('fetchReport result:', result)
                const reportURL = result.data.success.message
                console.log(reportURL)
                context.commit('set_url', reportURL)
            })
            .catch(err => {
                throw err
            })
    },

    getStatement(context, order_id) {
        return api
            .getStatement(order_id)
            .then(result => {
                console.log('getStatement result:', result)
                const reportURL = result.data.success.message
                console.log(reportURL)
                context.commit('set_url', reportURL)
            })
            .catch(err => {
                throw err
            })
    },
}

const getters = {}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
}
